/* eslint-disable */
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Resumeviewer from './ResumeViewer';
import MUIDataTable from 'mui-datatables';
import './Jobseeker.css';
import { connect } from 'react-redux';
import user from '../../src/components/images/User.png';
import { Viewer } from '@react-pdf-viewer/core';
import { themePlugin } from '@react-pdf-viewer/theme';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { Worker } from '@react-pdf-viewer/core';

import FormControl from '@mui/material/FormControl';

import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from '@mui/material';
import { BsFillCalendarEventFill } from 'react-icons/bs';
import { AiOutlineMail, AiOutlineEye, AiOutlineDownload, AiOutlineShareAlt, AiFillEye } from 'react-icons/ai';
import { BiArrowBack } from 'react-icons/bi';
import { FaBuilding } from 'react-icons/fa';

import { GoLocation } from 'react-icons/go';
import { IoPersonSharp } from 'react-icons/io5';
import { FaCommentDollar } from 'react-icons/fa';
import { BsBagCheckFill, BsFillTelephoneFill } from 'react-icons/bs';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import Key from '../clientVariables.json';
import { FcReading, FcViewDetails, FcGraduationCap, FcTodoList, FcInspection, FcDocument } from 'react-icons/fc';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/user';
import SessionAlert from 'src/SessionAlert';
import moment from 'moment';

import { showLoader } from '../constant/loader.action';
import { hideLoader } from '../constant/loader.action';

import { toast } from 'react-toastify';
import ToastMessage from '../components/ToastMessage';

import { Modal, Form } from 'react-bootstrap';
import FormControlLabel from '@mui/material/FormControlLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import request from 'src/utils/request';
import httpConfig, { postOptions } from 'src/utils/httpConfig';
import { FaSuitcase, FaRegBuilding, FaCalendarAlt } from 'react-icons/fa';
import { MdLocationOn } from 'react-icons/md';
import { ENDPOINT } from 'src/utils/endpoint';
import CustomToolBar from './customToolBar';
import * as XLSX from 'xlsx';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'user_id', label: 'Customer ID', alignRight: false },
  { id: 'company_name', label: 'Company Name', alignRight: false },
  { id: 'title', label: 'Plan Opted', alignRight: false },
  { id: 'package_end_date', label: 'Expiry Date', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },

  { id: 'status', label: 'Actions', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    return filter(array, (_user) => _user.company_name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

function User(props) {
  const history = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [jobsCount, setJobsCount] = useState(0);
  useEffect(() => {
    fetch(`${Key.domain}/company/getCompanyJobsCount`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(async (response) => {
      response.json().then(async (resdata) => {
        if (resdata.data.length > 0) {
          setCompanies(resdata.data);

          let totalJobsCount = 0;
          resdata.data.forEach((company) => {
            totalJobsCount += company.jobscountpostedbycompany;
          });

          setJobsCount(totalJobsCount);
        }
      });
    });
  }, []);

  const columns = [
    {
      label: <span>Company Name</span>,
      name: 'name',
      options: {
        customBodyRender: (value) => {
          return value ? <a style={{ cursor: 'pointer' }}>{value}</a> : 'N/A';
        },
      },
    },

    {
      label: <span>JobsCount</span>,
      name: 'jobscountpostedbycompany',

      options: {
        customBodyRender: (value, tableMeta, updateValue) => (
          <FormControlLabel
            control={
              <FormControl sx={{ m: 1, minWidth: 50 }}>
                <Button value={value}>{value ? value : 'N/A'}</Button>
              </FormControl>
            }
          />
        ),
      },
    },
  ];

  const options = {
    // filterType: 'checkbox',
    // responsive: 'standard',
    size: 'small',
    fixedHeader: true,
    density: false,
    selectableRows: false,
    search: true,
    filter: true,
    sort: false,
    download: true,
    print: false,
    viewColumns: false,
    onCellClick: (cellIndex, rowIndex) => {
      let selectedCompany = companies[rowIndex.dataIndex];

      console.log(selectedCompany);
      if (rowIndex.colIndex === 1) {
        console.log(selectedCompany);
        history('/dashboard/jobs-24hours', {
          state: { title: selectedCompany.name, count: selectedCompany.jobscountpostedbycompany },
        });
      }
    },
  };

  return (
    <div>
      <br />
      <br />
      <div className="jobseeker-conatiner" style={{ marginTop: '-40px', boxShadow: '0px 0px 5px black' }}>
        <MUIDataTable
          title={<h4>Companies and its JobsCount in Last 24 Hrs ( {jobsCount} )</h4>}
          data={companies}
          columns={columns}
          options={options}
        />
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader()),
  };
};

function mapStateToProps(state, ownProps) {
  return {
    currentUser: state.UserReducer.user,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(User);
